import type { Service } from '@/types';

export const services: Service[] = [
  {
    id: 'planiranje-projekata',
    title: 'Planiranje poslovnih projekata',
    eyebrow: 'Plan i prioriteti',
    shortDescription: 'Definišemo obim, odgovorne osobe, rokove i način praćenja pre početka realizacije.',
    description: 'Sa rukovodstvom i izvršnim timom razlažemo cilj na konkretne zadatke. Rezultat je operativni plan sa odgovornim osobama, realnim rokovima, zavisnostima i kriterijumima završetka.',
    image: 'https://images.unsplash.com/photo-1497366412874-3415097a27e7?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Sala u kojoj se priprema plan poslovnog projekta',
    benefits: [
      'Definisan obim i cilj projekta',
      'Raspored zadataka i odgovornosti',
      'Procena rizika i zavisnosti',
      'Dogovoren način izveštavanja'
    ]
  },
  {
    id: 'vodjenje-koordinacija',
    title: 'Vođenje i koordinacija',
    eyebrow: 'Realizacija',
    shortDescription: 'Koordiniramo učesnike, pratimo otvorene zadatke i pripremamo odluke koje projekat traži.',
    description: 'Preuzimamo svakodnevnu koordinaciju projekta: organizujemo sastanke, pratimo obaveze, vodimo evidenciju odluka i prijavljujemo odstupanja od plana pre nego što ugroze rok.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Prostor za koordinaciju učesnika projekta',
    benefits: [
      'Jedna odgovorna kontakt osoba',
      'Redovan status projekta',
      'Evidencija odluka i otvorenih pitanja',
      'Pravovremeno upravljanje rizicima'
    ]
  },
  {
    id: 'uredjenje-procesa',
    title: 'Uređenje digitalnih procesa',
    eyebrow: 'Jednostavniji rad',
    shortDescription: 'Dokumentujemo postojeći proces i uvodimo alate tamo gde smanjuju ručni rad i čekanje.',
    description: 'Mapiramo korake, odgovornosti i mesta na kojima se posao usporava. Zatim biramo jednostavan alat i pravila rada koje postojeći tim može da primeni bez nepotrebne promene celog sistema.',
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Uređen radni prostor sa digitalnom opremom',
    benefits: [
      'Dokumentovan postojeći proces',
      'Jasno definisane tačke poboljšanja',
      'Izbor alata prema stvarnoj potrebi',
      'Uputstvo i obuka korisnika'
    ]
  },
  {
    id: 'operativna-podrska',
    title: 'Operativna podrška',
    eyebrow: 'Praćenje primene',
    shortDescription: 'Pratimo primenu dogovorenog rešenja i pomažemo timu da otkloni probleme u svakodnevnom radu.',
    description: 'Nakon isporuke proveravamo kako rešenje funkcioniše u praksi, prikupljamo povratne informacije korisnika i predlažemo korekcije. Obim podrške dogovara se mesečno ili prema konkretnom zadatku.',
    image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Tim u prostoru za operativni rad',
    benefits: [
      'Dogovoren termin za odgovor',
      'Praćenje primene rešenja',
      'Evidencija problema i korekcija',
      'Mesečni ili projektni model podrške'
    ]
  }
];
